// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonPresentationProps } from "@insite/mobius/Button";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export const styledSlider = () => {
    return ({ theme }: any) => css`
        position: relative;
        .swiper-container {
            width: 100% !important;
        }
        .swiper-carousel {
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            z-index: 0;
        }
        .swiper-wrapper {
            box-sizing: border-box;
            z-index: 0;
        }
    `;
};

export interface BGSProductCarouselSlider {
    mainContainer?: InjectableCss;
    carouselWrapper?: InjectableCss;
    innerContainer?: InjectableCss;
    slide?: InjectableCss;
    scrollNext?: ButtonPresentationProps;
    scrollPrev?: ButtonPresentationProps;
    navigationWrapper?: InjectableCss;
}

export const bgsCarouselStyles = {
    mainContainer: {
        css: css`
            width: 100%;
            position: relative;
            @media print {
                display: none;
            }
        `,
    },
    carouselWrapper: {
        css: css`
            &&:before {
                content: " ";
                height: 100%;
                width: 200%;
                position: absolute;
                left: -200%;
                background: white;
                z-index: 2;
            }
            @media (max-width: 1280px) {
                overflow: hidden;
                padding: 20px 0;
                &:before {
                    content: none;
                }
            }
            @media (max-width: 600px) {
                padding-left: 1px;
            }
        `,
    },
    innerContainer: {
        css: css`
            display: flex;
        `,
    },
    slide: {
        css: css`
            width: calc(100% / 4);
            @media (max-width: 1024px) {
                width: calc(100% / 3 - 10px);
                margin: 0 5px;
            }
            @media (max-width: 1000px) {
                width: calc(100% / 2 - 20px);
                margin: 0 10px;
            }
            @media (max-width: 600px) {
                width: calc(100% - 16px);
                margin: 0 8px;
            }
        `,
    },
    navigationWrapper: {
        css: css`
            display: flex;
            align-items: center;
            position: absolute;
            top: -54px;
            right: 3px;
            @media (max-width: 600px) {
                top: -25px;
            }
        `,
    },
    scrollNext: {
        css: css`
            background: transparent !important;
            padding: 0;
            min-height: auto;
            border: 0;
            &&:focus {
                border: 0;
                outline-width: 1px !important;
            }
            &&& > span {
                color: ${getColor("tertiary")};
                &,
                svg {
                    width: 19px;
                    height: 19px;
                }
            }
        `,
    },
    scrollPrev: {
        css: css`
            background: transparent !important;
            padding: 0;
            min-height: auto;
            border: 0;
            &&:focus {
                border: 0;
                outline-width: 1px !important;
            }
            &&& > span {
                color: ${getColor("tertiary")};
                &,
                svg {
                    width: 19px;
                    height: 19px;
                }
            }
        `,
    },
};
